import { getUserService } from "@ntconnect/framework/pbx";

export const fetchUsers = (domain, page, pageSize, search, filter) =>
  getUserService().fetchUsers(domain, page, pageSize, search, filter);

export const fetchUser = (domain, id) =>
  getUserService().fetchUser(domain, id);

export const fetchUsersExtensions = (domain, userId, page, pageSize, search, filter) =>
  getUserService().fetchUsersExtensions(domain, userId, page, pageSize, search, filter);

export const createUserExtension = (domain, userId, extensionId) =>
  getUserService().createUserExtension(domain, userId, extensionId);

export const deleteUserExtension = (domain, userId, extensionId) =>
  getUserService().deleteUserExtension(domain, userId, extensionId);

export const createUser = (domain, params) =>
  getUserService().createUser(domain, params);

export const updateUser = (domain, id, params) =>
  getUserService().updateUser(domain, id, params);
